import React from 'react';
import get from 'lodash/get';
import Warning from './Warning';
import Table from './Table';
import { FarmContext, GEO_URL } from './FarmContext';



export default function County () {
  const { boundary } = React.useContext(FarmContext);
  const [county, setCounty] = React.useState({});

  React.useEffect(() => {
    if (boundary.features.length === 0) return;
    // TODO multiple counties? not just first
    fetch(GEO_URL + '/geoserver/nass_county', {
      method: 'POST',
      body: JSON.stringify({boundary: boundary.features[0]}),
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    })
      .then(r => r.json())
      .then(setCounty)
  }, [boundary]);


  if (boundary.features.length === 0) return <Warning text="No farm boundary, go and draw one on the farm map." />

  const countyName = get(county, ['county', 'properties', 'NAME']);

  // if (!intersected) return <Warning text="No US counties intersect your farm boundary." />

  // const headers = Object.keys(get(county, ['data', 0], {}));
  const headers = [
      'short_desc',
      'year',
      'Value',
      'unit_desc',
  ]
  /*
  check agg_level_desc == COUNTY
  and 
  reference_period_desc == YEAR
  */

  return <div>
    <h2 className="text-xl">
      {countyName ? (countyName + " County (data from the USDA)") : 'Loading...'}
    </h2>
    <h2 className="text-lg py-6">
      Rents
    </h2>
    <Table headers={headers} rows={get(county, 'rents', [])} />
    <h2 className="text-lg py-6">
      Field Crop Yields
    </h2>
    <Table headers={headers} rows={get(county, 'yields', [])} />
    <h2 className="text-lg py-6">
      Area Harvested
    </h2>
    <Table headers={headers} rows={get(county, 'areas', [])} />
  </div>
}